<template>
    <div>
        <v-select v-model="part" label="id" :filterable="false" :resetOnOptionsChange="resetOnOptionsChange" @search="onSearch" @input="onChange" :options="options" :value="selectedValues" :placeholder="`Search ${placeholder}`" :class="{'filter-select': forFilters, 'is-invalid': hasError}">
            <template slot="no-options">
                Search for Part Part#, Description, Color Code, or Customer
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.part_nbr }} - {{ option.description }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.part_nbr }} - {{ option.description }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            placeholder: {
                type: String,
                default: 'Part',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            resetOnOptionsChange: {
                type: Boolean,
                default: false,
            }
        },

        data: function() {
            return {
                options: [],
                part: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            }
        },

        methods: {
            //Search
            onSearch: function(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/parts', {query: searchTerm})
                    .then(res => {
                        //Set the data
                        this.options = res.data.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            onChange: function (selected) {
                //Emit
                this.$emit('partSelected', this.part);
            },

            reset(){
                //Set to null
                this.part = null;
                this.selectedValues = null;
                this.options = [];
            }
        },

        mounted() {
            //Push the selected value. Null will default to the placeholder
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.part = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }
</style>